<template>
  <button
    v-wave
    class="template-card flex-none w-[200px] p-3.5 rounded-md bg-white border border-gray-200 flex flex-col gap-2 relative text-right cursor-pointer hover:border-primary-200 transition-colors"
    @click="$emit('click')"
  >
    <span
      v-if="template.showOnWebsite !== false"
      class="absolute top-2.5 left-2.5 inline-flex items-center gap-1 text-[10px] font-medium px-1.5 py-0.5 rounded bg-green-100 text-green-700"
    >
      <span class="w-1 h-1 rounded-full bg-green-600" />
      באתר
    </span>
    <span
      v-else
      class="absolute top-2.5 left-2.5 text-[10px] font-medium px-1.5 py-0.5 rounded bg-gray-100 text-gray-500"
    >
      לשיוך ידני
    </span>

    <div class="w-9 h-9 rounded-full flex items-center justify-center bg-gradient-to-br from-[#ddd8fc] to-[#a691f4]">
      <i class="pi pi-id-card text-base text-primary" />
    </div>

    <div>
      <div class="text-sm font-semibold text-gray-900 truncate">{{ template.name }}</div>
      <div class="text-[11px] text-gray-500 mt-0.5">
        {{ template.totalUses }} מימושים
        <template v-if="template.validityMonths"> · תוקף {{ template.validityMonths }} ח׳</template>
      </div>
    </div>

    <div class="flex items-baseline gap-1.5">
      <span class="text-lg font-semibold">₪{{ template.price }}</span>
      <span v-if="originalPrice && originalPrice > template.price" class="text-[11px] text-gray-400 line-through">₪{{ originalPrice }}</span>
      <span
        v-if="discount > 0"
        class="text-[10px] font-medium px-1.5 py-0.5 rounded bg-amber-100 text-amber-800 mr-auto"
      >−{{ discount }}%</span>
    </div>
  </button>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { IBundlePackTemplate } from '@torim-app/types';

const props = defineProps({
  template: {
    type: Object as PropType<IBundlePackTemplate>,
    required: true
  },
  originalPrice: {
    type: Number,
    required: false
  }
});

defineEmits<{ (e: 'click'): void }>();

const discount = computed(() => {
  if (!props.originalPrice || props.originalPrice <= props.template.price) return 0;
  return Math.round(((props.originalPrice - props.template.price) / props.originalPrice) * 100);
});
</script>

<style scoped>
.template-card {
  scroll-snap-align: start;
}
</style>
